import { FC } from 'react'

import clsx from 'clsx'

import { DayProps } from '../model'

import s from './styles.module.scss'

export const ActiveDay: FC<DayProps> = ({
  day,
  content,
  isGreen,
  color,
  isCurrentDay,
  onClick,
}) => {
  return (
    <div
      className={clsx(s.container, { [s.currentDay]: isCurrentDay })}
      onClick={() => onClick?.(day)}
    >
      <p className={clsx('bold-14')}>{day}</p>
      <span
        className={clsx('regular-10', { [s.green]: isGreen })}
        style={{ color }}
      >
        {content}
      </span>
    </div>
  )
}
